<template>
  <div>
    <a-tabs v-model="activeKey" style="margin-top: -4px">
      <a-tab-pane key="shelfByOrder" :tab="$t('tab.shelfByOrder')" style="margin-top: -14px">
        <shelf-by-order ref="shelfByOrder"/>
      </a-tab-pane>
      <a-tab-pane key="shelfByArgs" :tab="$t('tab.shelfByArgs')" forceRender style="margin-top: -14px">
        <shelf-by-args ref="shelfByArgs"/>
      </a-tab-pane>
      <a-tab-pane key="shelfByStereoscopic" :tab="$t('tab.shelfByStereoscopic')" forceRender style="margin-top: -14px">
        <shelf-by-stereoscopic ref="shelfByStereoscopic"/>
      </a-tab-pane>
      <a-space slot="tabBarExtraContent">
        <a-button :disabled="shelfDisabled" type="primary" @click="confirm">{{ $t('button.shelfConfirm') }}</a-button>
        <a-button type="primary" @click="query">{{ $t('button.query') }}</a-button>
        <a-button type="primary" @click="reset">{{ $t('button.reset') }}</a-button>
      </a-space>
    </a-tabs>
  </div>
</template>
<script>
import ShelfByOrder from '@/views/inbound/shelf/ShelfByOrder.vue'
import ShelfByArgs from '@/views/inbound/shelf/ShelfByArgs.vue'
import ShelfByStereoscopic from '@/views/inbound/shelf/ShelfByStereoscopic.vue'

export default {
    name: 'Shelf',
    components: {ShelfByStereoscopic, ShelfByArgs, ShelfByOrder},
    data() {
      return {
        activeKey: 'shelfByOrder',
        shelfDisabled: false
      }
    },
    watch: {
      activeKey(key) {
        if (key === 'shelfByStereoscopic') {
          this.shelfDisabled = true
        } else {
          this.shelfDisabled = false
        }
      }
    },
    methods: {
      query() {
        this.$refs[this.activeKey].refresh()
      },
      reset() {
        this.$refs[this.activeKey].reset()
      },
      confirm() {
        this.$refs[this.activeKey].confirm()
      }
    }

  }
</script>